import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { Badge } from '../../ui/badge';

function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

const EVENT_LABELS = {
  plan_activated: 'Plan activated',
  plan_upgraded: 'Plan upgraded',
  plan_downgraded: 'Plan downgraded',
  plan_renewed: 'Plan renewed',
  addon_activated: 'Add-on activated',
  addon_cancelled: 'Add-on cancelled',
  auto_renew_changed: 'Auto-renew updated',
  subscription_cancelled: 'Subscription cancellation scheduled',
  payment_success: 'Payment',
};

export default function BillingHistorySection({ payments = [], activity = [], compact = false }) {
  const paidPayments = (payments || []).filter((p) => p.status === 'paid');

  return (
    <div className={compact ? 'space-y-4' : 'space-y-6'}>
      <Card>
        <CardHeader className={compact ? 'pb-2' : undefined}>
          <CardTitle className={compact ? 'text-base' : undefined}>Payment history</CardTitle>
          <CardDescription>Completed SkipCash and card payments</CardDescription>
        </CardHeader>
        <CardContent>
          {paidPayments.length === 0 ? (
            <p className="text-sm text-slate-500">No payments yet.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b text-left text-slate-500">
                    <th className="py-2 pr-3">Date</th>
                    <th className="py-2 pr-3">Description</th>
                    <th className="py-2 pr-3">Amount</th>
                    <th className="py-2">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paidPayments.map((p) => (
                    <tr key={p.id} className="border-b border-slate-100 dark:border-slate-800">
                      <td className="py-2 pr-3 whitespace-nowrap">{fmtDate(p.paid_at || p.created_at)}</td>
                      <td className="py-2 pr-3">{p.description || p.product_type || 'Payment'}</td>
                      <td className="py-2 pr-3 font-medium">
                        ${Number(p.amount_usd || 0).toFixed(2)}
                      </td>
                      <td className="py-2">
                        <Badge variant="secondary">{p.status}</Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader className={compact ? 'pb-2' : undefined}>
          <CardTitle className={compact ? 'text-base' : undefined}>Billing activity</CardTitle>
          <CardDescription>Plan changes, add-ons, and renewals</CardDescription>
        </CardHeader>
        <CardContent>
          {(activity || []).length === 0 ? (
            <p className="text-sm text-slate-500">No activity yet.</p>
          ) : (
            <ul className="space-y-3 text-sm">
              {(activity || []).map((ev) => (
                <li
                  key={ev.id}
                  className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 border-b border-slate-100 dark:border-slate-800 pb-3 last:border-0"
                >
                  <div>
                    <p className="font-medium text-slate-900 dark:text-slate-100">
                      {EVENT_LABELS[ev.event_type] || ev.event_type}
                    </p>
                    <p className="text-slate-600 dark:text-slate-400">{ev.summary}</p>
                  </div>
                  <div className="text-slate-500 shrink-0 text-right">
                    <p>{fmtDate(ev.created_at)}</p>
                    {ev.amount_usd != null && (
                      <p className="font-medium text-slate-700 dark:text-slate-300">
                        ${Number(ev.amount_usd).toFixed(2)}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
